export default "__VITE_ASSET__636d513d__"